// extracted by mini-css-extract-plugin
export const aside = "Layouts__aside__FtwCq";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const centeredColumn = "Layouts__centeredColumn__gcEB1";
export const centeredColumnWrapper = "Layouts__centeredColumnWrapper__S1Tdm";
export const column = "Layouts__column__gl4kQ";
export const flexLayout = "Layouts__flexLayout__vGpM-";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "Layouts__header__RaZc4";
export const limitedWidth = "Layouts__limitedWidth__ZT-z9";
export const main = "Layouts__main__Blgt9";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sidebarLayout = "Layouts__sidebarLayout__oyuKj";
export const sidebarTopLayer = "Layouts__sidebarTopLayer__cBIfo";
export const singleColumn = "Layouts__singleColumn__P3M0Q";
export const textCenter = "Layouts__textCenter__-CT8D";
export const twoColumnRowLayout = "Layouts__twoColumnRowLayout__4JhRl";